import { excludeProps, mixins, styled } from '@bob/library'
import { GatsbyLinkProps, Link } from 'gatsby'
import { FC } from 'react'

export type SpotLinkTypes = 'primary' | 'secondary' | 'tertiary'
export type SpotLinkVariants = 'blue' | 'white' | 'black' | 'green'

export type SpotLinkProps = {
  ctaType: SpotLinkTypes
  ctaVariant: SpotLinkVariants
  noStyles?: boolean
  isEmpty?: boolean
}

export const StyledButton = styled.button<SpotLinkProps>`
  ${(p) => (p.noStyles ? '' : mixins.cta[p.ctaType](p.ctaVariant))}
  cursor: ${(p) => (p.isEmpty ? 'unset' : 'pointer')};
`

export const StyledAnchor = styled.a<SpotLinkProps>`
  max-width: 100%;
  ${(p) => (p.noStyles ? '' : mixins.cta[p.ctaType](p.ctaVariant))}
  cursor: ${(p) => (p.isEmpty ? 'unset' : 'pointer')};
`

export const StyledLink = styled(
  // Needed to cast as FC for now. Not sure how to get around.
  excludeProps(
    Link as unknown as FC<GatsbyLinkProps<any>>,
    'ctaType',
    'ctaVariant',
    'noStyles',
    'isEmpty'
  )
)<SpotLinkProps>`
  ${(p) => (p.noStyles ? '' : mixins.cta[p.ctaType](p.ctaVariant))}
  cursor: ${(p) => (p.isEmpty ? 'unset' : 'pointer')};
`
